import React from 'react';

import {
  BulletPoints,
  ContentRow,
  DestinationDataWrapper,
  DestinationNameText,
  InfoRow,
  Line,
  LocationNameText,
  LocationWrapper,
  ResendSignText,
  ShippingCompany,
  ShippingCompanyIcon,
  TransportDataContainter,
} from './styles';

import Mask from '../../../../../../utils/Mask';
import defaultLogo from '../../../../../../assets/images/icn_truck-empresa-2.png';

const TransportData = ({
  origin,
  reDelivery,
  destination,
  shippingCompany,
  isDesktop,
  isMobile,
  isTablet,
}) => {
  const realDestination = reDelivery || destination;

  const reDeliveryText = 'Redespacho';

  return (
    <TransportDataContainter
      isDesktop={isDesktop}
      isTablet={isTablet}
      isMobile={isMobile}
    >
      <LocationWrapper>
        <InfoRow>
          <BulletPoints />
          <LocationNameText>{`${origin.city}- ${origin.stateAbbr}`}</LocationNameText>
        </InfoRow>
        <InfoRow>
          <Line />
          <ShippingCompany>
            <ShippingCompanyIcon src={shippingCompany?.icon || defaultLogo} alt='Logo' />
            <span>{shippingCompany?.corporateName || Mask.cnpj(shippingCompany?.cnpj)}</span>
          </ShippingCompany>
        </InfoRow>
        <InfoRow lastRow>
          <BulletPoints />
          <ContentRow>
            <DestinationDataWrapper>
              <LocationNameText>{`${realDestination.city}- ${realDestination.stateAbbr}`}</LocationNameText>
              {reDelivery ? <ResendSignText>({reDeliveryText})</ResendSignText> : null}
            </DestinationDataWrapper>
            <DestinationNameText>{realDestination.name}</DestinationNameText>
          </ContentRow>
        </InfoRow>
      </LocationWrapper>
    </TransportDataContainter>
  );
};
export default TransportData;
